<template>
  <div class="bb-contact-finances">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-contact-finances-header">
      <div class="bb-contact-finances-header-balance"
           :class="{
             'bb-contact-finances-header-balance_positive': clientPayments > 0,
             'bb-contact-finances-header-balance_negative': clientPayments < 0,
           }">
        <span class="bb-contact-finances-header-balance__status">{{statusOverpaid}}</span>
        <i class="icon-warn bb-contact-finances-header-balance__icon"></i>
        <span class="bb-contact-finances-header-balance__number">
          {{convertNumber(Math.abs(clientPayments))}}
        </span>
      </div>
      <div class="bb-contact-finances-header-buttons">
        <button class="bb-button bb-contact-finances-header-buttons__button"
                @click.stop="goToCreditNotes">
          CREDIT NOTES
        </button>
        <button class="bb-button bb-contact-finances-header-buttons__button"
                @click.stop="showHistoryWriteOff = true">
          WRITE OFFS
        </button>
      </div>
    </div>
    <div class="bb-contact-finances-totals">
      <TotalCard class="bb-contact-finances-totals__item"
                 :class="{
                   'bb-contact-finances-totals__item_active': '&' + total.filter === filterByStatus,
                   'bb-contact-finances-totals__item_pointer': total.filter,
                   'bb-contact-finances-totals__item_disabled': key === 'received'
                 }"
                 :key="total.id"
                 v-if="key !== 'income'"
                 v-for="(total, key) in totalsInvoicesCard"
                 @setFilter="setFilterByTotal"
                 :filter="total.filter"
                 :title="total.title"
                 :icon="total.icon"
                 :sum="total.sum"
                 :info="total.info"
                 :colorSum="total.color"/>
    </div>
    <div class="bb-contact-finances-table__wrapper">
        <Table :options="optionsTable"
               heightTable="calc(100vh - 351px)"
               :min-width="700"
               :no-fixed="true"
               :total-pages="fullInfo.totalPages"
               :hide-toolbar="true"/>
      <Pagination :data="fullInfo" :getQuery="getInvoices" :limit="defLimit" class="bb-pagination"/>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="showHistoryWriteOff"
                   @close="showHistoryWriteOff = false"
                   :title="'WRITE-OFFS OF ' + nicknameClient.toUpperCase()"
                   :tableMode="true"
                   @click.stop>
        <ContactWriteOffs @openProforma="openProforma"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="proformaOpen = false" v-if="proformaOpen">
        <ProformaInvoice @close="proformaOpen = false"
                         :view-mode="true"
                         :editable-invoice="editableInvoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="balanceByInvoiceOpen = false" v-if="balanceByInvoiceOpen">
        <BalanceByInvoices @saveBalance="saveBalance"
                           @openProforma="openProformaCreditNote"
                           :soaInvoice="invoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="creditNoteProforma" @close="closeCreditNoteProforma">
        <template v-slot:buttons>
          <div class="bb-contact-finances__send">
            <ButtonsEdit @edit="proformaEvents.create()"
                         @delete="proformaEvents.cancel()"
                         styles="accent"
                         no-pop-up="false"
                         :left-if="true"
                         btn-right-text="CANCEL"
                         btn-left-text="SAVE"/>
          </div>
        </template>
        <CreditNoteProforma ref="proformaCreditNote"
                            :invoiceId="invoiceId"
                            @close="closeCreditNoteProforma"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import {get, set, findIndex} from 'lodash'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import Pagination from '@/components/Main/Pagination/Pagination'
import Table from '@/components/Main/Table/Table'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import totalsInvoicesCard from '@/constants/totalsInvoicesCard'
import convertNumber from '@/mixin/convertNumber'
import {contactFinancesTable, contactFinancesTableColumns} from '@/constants/TablesOptions/contactsFinancesTable'
import InvoicesApi from '@/api/Invoce/api'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import BalanceByInvoices from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/BalanceByInvoices'
import CreditNoteProforma from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import UploadFileApi from '@/api/UploadFile/api'
import ContactWriteOffs from '@/components/Dissemination/Sales/CRM/ContactCard/ContactWriteOffs/ContactWriteOffs'
import clientNickname from '@/mixin/clientNickname'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {saveAs} from 'file-saver'
import b64toBlob from 'b64-to-blob'
import {soaStatusList} from '@/constants/soaStatusList'

export default {
  name: 'ContactFinances',
  components: {
    ContactWriteOffs,
    TotalCard,
    Table,
    Pagination,
    VuePerfectScrollbar,
    BalanceByInvoices,
    ButtonsEdit,
    CreditNoteProforma,
    ModalWindow,
    ProformaInvoice,
    LoaderFly
  },
  mixins: [convertNumber, clientNickname],
  data () {
    return {
      loaderRun: false,
      editableInvoice: {
        invoice: {}
      },
      showHistoryWriteOff: false,
      proformaOpen: false,
      listSoaStatus: soaStatusList,
      balanceByInvoiceOpen: false,
      creditNoteProforma: false,
      invoiceId: '',
      invoice: {},
      proformaEvents: {
        create: false,
        cancel: false
      },
      defLimit: 25,
      filterBySoaStatus: [],
      fullInfo: {},
      defaultFilter: '&status[]=1&status[]=2&&status[]=3',
      filterByStatus: '&status[]=1&status[]=2&&status[]=3',
      totalsInvoicesCard: totalsInvoicesCard,
      clientPayments: 0,
      optionsTable: contactFinancesTable,
      crypt: true,
      files: {}
    }
  },
  computed: {
    contactsFinancesColumnsData: {
      get: function () {
        return this.$store.getters.contactsFinancesColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsFinancesColumnsData', data)
      }
    },
    contactsFinancesRowsData: {
      get: function () {
        return this.$store.getters.contactsFinancesRowsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsFinancesRowsData', data)
      }
    },
    statusOverpaid () {
      return this.clientPayments > 0 ? 'Overpaid' : 'Underpaid'
    },
    filterByClient () {
      return `client[]=${this.clientInfo.id}` + '&isDelete[]=false'
    },
    clientInfo () {
      return this.$store.getters.clientInfo
    }
  },
  methods: {
    setFiltersTotal () {
      set(this.totalsInvoicesCard, 'invoiced.filter', 'status[]=1&status[]=2&status[]=3')
      set(this.totalsInvoicesCard, 'underpaid.filter', 'status[]=1')
      set(this.totalsInvoicesCard, 'received.filter', false)
    },
    addActions () {
      this.contactsFinancesColumnsData.forEach(item => {
        if (item.actions) {
          item.actions.getFile = this.openFile
          item.actions.filter = this.setFilter
        }
        if (item.hover && item.property === 'number') {
          item.clickAction = this.openProforma
        }
        if (item.property === 'soaStatus') {
          item.clickAction = this.openBalance
        }
      })
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file.id)
    },
    getFile (id) {
      this.loaderRun = true
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    setFilter (data, item, property) {
      if (data) {
        const res = {
          query: `&${property}[]=${item.id}`,
          id: item.id
        }
        this.filterBySoaStatus.push(res)
      } else {
        const index = findIndex(this.filterBySoaStatus, {id: item.id})
        this.filterBySoaStatus.splice(index, 1)
      }
      this.getInvoices({})
    },
    openProforma (row) {
      const idFromFullList = get(row, 'id', false)
      const idFromWriteOffs = get(row, 'invoice.id', false)
      const id = idFromFullList || idFromWriteOffs
      if (!id) return
      InvoicesApi.getInvoiceById(id)
        .then(resp => {
          this.editableInvoice = {
            invoice: resp.data
          }
          this.proformaOpen = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    saveBalance (invoiceId) {
      this.loaderRun = true
      InvoicesApi.getSoaConsumed(invoiceId)
        .then((resp) => {
          this.loaderRun = false
          this.balanceByInvoiceOpen = false
          this.getInvoices({})
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
          this.loaderRun = false
        })
    },
    openBalance (row) {
      this.invoice = row
      this.balanceByInvoiceOpen = true
    },
    openProformaCreditNote (id) {
      this.balanceByInvoiceOpen = false
      this.creditNoteProforma = true
      this.invoiceId = id
    },
    closeCreditNoteProforma () {
      this.creditNoteProforma = false
      this.balanceByInvoiceOpen = true
    },
    roundNum (num) {
      return Math.round(num * 100) / 100
    },
    getSoaStatus () {
      this.contactsFinancesColumnsData.forEach(item => {
        if (item.listName === 'statusSoa') {
          item.list = this.listSoaStatus
        }
      })
    },
    getTotalPayments () {
      const query = this.filterByClient + '&status[]=1&status[]=2&&status[]=3'
      InvoicesApi.getInvoicesTotal({query})
        .then((resp) => {
          const overpaid = get(resp.data, 'totalOverpaid', 0)
          const underpaid = get(resp.data, 'totalUnderpaid', 0)
          this.clientPayments = this.roundNum(overpaid - underpaid)
        })
        .catch(e => console.error(e))
    },
    getInvoicesTotal () {
      const query = this.filterByClient + this.filterByStatus
      InvoicesApi.getInvoicesTotal({query})
        .then((resp) => {
          const totalInvoiced = get(resp.data, 'totalInvoiced', 0)
          const totalReceived = get(resp.data, 'totalReceived', 0)
          const overpaid = get(resp.data, 'totalOverpaid', 0)
          const notPaid = get(resp.data, 'totalNoPaid', 0)
          const underpaid = get(resp.data, 'totalUnderpaid', 0)
          this.totalsInvoicesCard.invoiced.sum = this.roundNum(totalInvoiced)
          this.totalsInvoicesCard.received.sum = this.roundNum(totalReceived)
          this.totalsInvoicesCard.overpaid.sum = this.roundNum(overpaid)
          this.totalsInvoicesCard.underpaid.sum = this.roundNum(underpaid + notPaid)
        })
        .catch(e => console.error(e))
    },
    getInvoices ({page}) {
      this.getInvoicesTotal()
      let query = this.filterByClient + this.filterByStatus
      if (this.filterBySoaStatus.length) {
        query += this.filterBySoaStatus.reduce((str, item) => {
          return str + item.query
        }, '')
      }
      this.loaderRun = true
      InvoicesApi.getInvoices({limit: this.defLimit, page, query})
        .then((resp) => {
          this.fullInfo = resp.data
          this.contactsFinancesRowsData = resp.data.invoices
          this.loaderRun = false
        })
        .catch(e => {
          this.loaderRun = false
          console.error(e)
        })
    },
    goToCreditNotes () {
      const params = {
        tab: 'invoice-tracking',
        activeTable: 4
      }
      this.$router.push({name: 'FinanceIncome', params: params})
    },
    setFilterByTotal (value) {
      const filter = '&' + value
      this.filterByStatus = filter === this.filterByStatus ? this.defaultFilter : filter
      this.getInvoices({})
    }
  },
  updated () {
    if (this.$refs.proformaCreditNote) {
      this.proformaEvents.create = this.$refs.proformaCreditNote.createCreditNote
      this.proformaEvents.cancel = this.$refs.proformaCreditNote.cancelProforma
    }
  },
  beforeMount () {
    this.contactsFinancesColumnsData = contactFinancesTableColumns
    this.getInvoices({})
    this.getTotalPayments()
    this.addActions()
    this.setFiltersTotal()
    this.getSoaStatus()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-finances {
    @include global-font;
    min-width: 700px;

    &-header {
      margin: 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 42px;

      &-balance {
        font-weight: 500;
        font-size: 13px;
        cursor: default;
        color: $color-gray;

        &_negative {
          color: $color-pomegranate;
        }

        &_positive {
          color: $color-japanese-laurel;
        }

        &__number {
          font-weight: bold;
        }
      }

      &-buttons {
        display: inline-grid;
        grid-template-columns: repeat(auto-fit, 125px);
        max-width: 260px;
        grid-gap: 10px;
        align-items: center;
        justify-content: center;

        &__button {
          font-weight: 600;
          padding: 0 14px;
        }
      }
    }

    &-totals {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      grid-gap: 24px;
      margin: 10px 25px 20px;

      &__item {
        box-shadow: 0 0 20px rgba($color-black, 0.05);
        transition: 0.3s;

        &_disabled {
          pointer-events: none;
        }

        &_active {
          box-shadow: 0 0 20px rgba($color-black, 0.1);
        }

        &_pointer {
          cursor: pointer;

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &-table {
      &__wrapper {
        margin: 0 20px 0 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactFinances/ContactFinances.vue